import { fetchOrganizations } from '../client/organization';
import {
  ORGANIZATION_TYPE,
  ORGANIZATION_TYPE_OPTIONS,
  SORT_ORGANIZATIONS,
  SUBSCRIPTION_TYPE,
} from '../constants';
import { openUrlInNewTab } from './shared';
import { checkIsUserSuperAdmin } from './user';

export const organizationLevels = () => {
  const organizationLevels = [];

  // TODO Refactor for loop
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(SUBSCRIPTION_TYPE)) {
    organizationLevels.push({
      label: key,
      value,
    });
  }

  return organizationLevels;
};

export const findObjectByValue = (allValuesArray, value) =>
  allValuesArray.find((obj) => obj.value === value);

export const getUsersAvailableBrands = (allBrands, usersBrand) => {
  return checkIsUserSuperAdmin()
    ? allBrands
    : allBrands.filter(({ value }) => usersBrand.split(',').includes(value));
};

export const generateBrandOptions = (data) =>
  data.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

export const createOrganizationsOptions = (organizations) =>
  organizations.map(({ id, name, type }) => ({
    value: id,
    label: name,
    type,
    handleClick: () => openUrlInNewTab(`/organizations/${id}`),
  }));

/// /////// fetching organizations for connected organizations feature //////////
export const loadOrganizations = async (
  type = ORGANIZATION_TYPE.CUSTOMER,
  brand,
  searchValue = '',
  page,
  organizationId = ''
) => {
  try {
    const {
      data: { data: fetchedOrganizations, rowCount },
    } = await fetchOrganizations({
      SearchTerm: searchValue || '',
      Size: 30,
      PageNumber: page,
      FilterType: [type],
      FilterBrand: brand ? [brand] : [],
      Sort: SORT_ORGANIZATIONS,
      ConnectedOrganizationsForOrganizationId: organizationId || null,
    });

    return {
      data: createOrganizationsOptions(fetchedOrganizations),
      total: rowCount,
    };
  } catch {
    console.error('Error loading organizations');
  }
};

/// //////////////////////////////////////////////////////////////////////////////

export const getUsersAvailableOrganizationTypeOptions = () =>
  checkIsUserSuperAdmin()
    ? ORGANIZATION_TYPE_OPTIONS
    : ORGANIZATION_TYPE_OPTIONS.filter(
        ({ availableForBrandAdmin }) => availableForBrandAdmin
      );

// temporary solution for nested address fields issue
export const organizeNestedFields = (object) => {
  const result = {};

  Object.entries(object).forEach(([key, value]) => {
    const keys = key.split('.');

    keys.reduce((acc, part, index) => {
      if (index === keys.length - 1) {
        acc[part] = value;
      } else {
        acc[part] = acc[part] || {};
      }
      return acc[part];
    }, result);
  });

  return result;
};

// temporary solution for nested address fields issue
export const flattenAddressFieldsInOrganizationObject = (obj = {}) => {
  const result = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (['billingAddress'].includes(key) && value) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        result[`${key}.${nestedKey}`] = nestedValue;
      });
    } else if (['deliveryAddresses'].includes(key) && Array.isArray(value)) {
      result[key] = value.map((addr) => ({
        ...addr,
        country: addr.country || null,
      }));
    } else {
      result[key] = value;
    }
  });

  return result;
};

export const getCountryFromCode = (countryCode, countries) => {
  const { label = countryCode } =
    countries.find((item) => item.value === countryCode) || {};

  return label;
};
